// extracted by mini-css-extract-plugin
export default {"zoomModal":"XZ-z"};